module.exports = __webpack_public_path__ + "img/008冯强.d8664bfd.png";